export const navigation = [
  { name: "About", href: "#about" },
  { name: "Services", href: "#services" },
  // { name: "Team", href: "#certification" },
  { name: "Contact", href: "mailto:sbarber@tektondigital.com" },
]
